(() => {
  'use strict';
  function init(scope = document) {
    const menu = scope.querySelector('.site-menu-toggle');
    const nav = scope.querySelector('#site-nav');
    if (menu && !menu.dataset.ready) {
      menu.dataset.ready = 'true';
      menu.addEventListener('click', () => {
        const open = menu.getAttribute('aria-expanded') !== 'true';
        menu.setAttribute('aria-expanded', String(open));
        nav.classList.toggle('is-open', open);
      });
      menu.closest('header').addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        menu.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-open');
        menu.focus();
      });
    }
    window.NB.initStaticBracelets(scope);
    scope.querySelectorAll('[data-card-necklace],[data-home-necklace]').forEach(svg => {
      if (svg.__nb) return;
      svg.__nb = new window.NB.Necklace(svg, {shadow:false});
      svg.__nb.render({name:'Momo', font:'03', palette:svg.dataset.color || 'gold'});
    });
    scope.querySelectorAll('[data-local-filters]').forEach(filters => {
      if (filters.dataset.ready) return;
      filters.dataset.ready = 'true';
      const select = filters.querySelector('[data-color-filter]');
      const cards = filters.parentElement.querySelectorAll('[data-product-card]');
      function update() {
        let count = 0;
        cards.forEach(card => {
          card.hidden = !!select.value && !card.dataset.colors.split('|').includes(select.value);
          if (!card.hidden) count++;
        });
        filters.querySelector('[data-result-count]').textContent = count + window.CariamText("copy.text_221", '件');
      }
      select.addEventListener('change', update);
      update();
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-bracelet-static],[data-card-necklace],[data-home-necklace]').forEach(svg => svg.__nb?.destroy());
  });
})();

// Keep the native submit button usable with or without automatic submission.
(() => {
  function syncLocale(form) {
    const select = form.querySelector('[data-locale-select]');
    const code = form.querySelector('[data-locale-code]');
    if (select && code) {
      code.value = select.value;
      code.disabled = false;
      select.removeAttribute('name');
    }
  }
  document.addEventListener('submit', event => {
    if (event.target.matches('.language-switcher')) syncLocale(event.target);
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-locale-select]')) return;
    const form = event.target.closest('form');
    syncLocale(form);
    form.requestSubmit();
  });
})();
